<template>
    <div class="mbody mbody2">
        <h1 style="justify-content: center;display: flex;" class="tit">My NFTs</h1>

        <hr class="rounded">

        <div style="text-align: center;color: red;" v-if="$store.state.wallet_manager == undefined">Please download a
            wallet</div>


        <CoalSetPriceCompVue :nft="cur_set_price_nft"></CoalSetPriceCompVue>


        <LoadingComp v-show="is_loading"></LoadingComp>

        <div v-show="!is_loading" class="mynftsbody">
            <div class="mynftsitem" v-for="(nft, nftidx) in loaded_nfts" :key="nftidx">
                <div>
                    <CoalRend :nft="nft"></CoalRend>
                </div>
                <div>

                    <table class="mytableitem">
                        <tr>
                            <td>id</td>
                            <td>:</td>
                            <td>

                                <div :title="nft.is_in_grace() ? 'remaining grace period : ' + nft.get_remaining_grace() : ''"
                                    :class="nft.is_in_grace() ? 'grace' : ''"># {{ nft.get_id() }}</div>
                            </td>
                            <td><button @click="send_to_mine(nft)">mine</button></td>
                        </tr>
                        <tr>
                            <td>strength</td>
                            <td>:</td>
                            <td>{{ nft.get_strength() }} / 256</td>
                            <td><button @click="send_to_heist(nft)">strengthen</button></td>
                        </tr>

                        <tr>
                            <td>price</td>
                            <td>:</td>
                            <td>{{ nft.get_price() }} $KDA </td>
                            <td><button @click="set_price(nft)">set</button></td>
                        </tr>
                        <tr>
                            <td>on-sale</td>
                            <td>:</td>
                            <td>
                                <div v-bind:class="nft.get_sale_state() ? 'yesclass' : 'noclass'">{{
                                        nft.get_sale_state() ?
                                            'yes' : 'no'
                                }}</div>

                            </td>

                            <td><button @click="set_price(nft)">set</button></td>
                        </tr>

                        <tr>
                            <td>minter</td>
                            <td>:</td>
                            <td>{{ nft.get_minter() }}</td>
                            <td></td>
                            <!-- <td><button @click="transfer(nft)">strengthen</button></td> -->
                        </tr>

                        <tr>
                            <td>mint-date</td>
                            <td>:</td>
                            <td>{{ nft.get_date_formatted() }}</td>
                            <td></td>
                        </tr>

                    </table>
                </div>
            </div>
        </div>
        <hr class="rounded">


    </div>
</template>

<script>
import LoadingComp from '../LoadingComp.vue';
import CoalSetPriceCompVue from './CoalSetPriceComp.vue';
import CoalRend from './CoalRend.vue';
import ENUMS from '../Enums';
import { get_nft_strength_from_hash, date_formatter, get_nft_manager } from '@/utility'


export default {
    name: ENUMS.VIEWS.MYNFTS
    , data() {
        return {
            ENUMS: ENUMS
            , loading: true
            , loaded_nfts: []
            , selected_nft: undefined
            , cur_set_price_nft: undefined
        };
    }
    , computed: {
        is_loading() {
            return this.loading
        }
        , selected_nft_id() {
            return this.selected_nft ? this.selected_nft.id : ""
        }
    }
    , mounted() {
        this.reload()

    }
    , methods: {
        set_price(nft) {
            this.cur_set_price_nft = nft
            setTimeout(() => {

                document.getElementById("pris_id").focus()
            }, 100);
        }
        , reload() {
            var qthis = this

            get_nft_manager(qthis).then((x) => x.all_owned_by_wallet()).catch(() => {
                // TODO handle error
                console.log("caught badnfts")
            }).then((x) => {
                console.log("hr",x)
                qthis.loading = false
                qthis.loaded_nfts = x.get_nfts()
            }).finally(() => {
                qthis.loading = false

            })
        }
        , send_to_mine(x) {
            this.$store.state.mine_manager.add_miner(x)

        }
        , send_to_heist(x) {
            this.$store.state.nfr_cur = x.get_id()
            this.$store.state.nfr_manager.add_nfr_from_nft(x)

        }
        , selected(x) {
            this.selected_nft = x
            window.scrollTo(0, 0);
        }
        , get_nft_strength_from_hash
        , date_formatter
        , get_nft_manager
    }
    , components: { LoadingComp, CoalSetPriceCompVue, CoalRend }
}

</script>

<style scoped>
.hashov:hover {
    text-decoration: underline;
}

td:nth-child(3) {
    text-align: center;
}

.yesclass {
    color: greenyellow;
}

.grace {
    color: greenyellow;
    text-decoration: underline;
}

.grace:hover {
    text-decoration: none;
}
</style>